import React from 'react'
import { analytics } from './firebase'
import { setUserProperties  } from "firebase/analytics";
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router'
import { ID_CONSIGNEE, ID_RESELLER } from './actions/constant';


const idType = localStorage.getItem('tolaut@typeUser') || null;
const form = localStorage.getItem('tolaut@form') || null;
const email = localStorage.getItem('tolaut@email') || null;
const expired_pi = localStorage.getItem('tolaut@pi_expired') || null;
const skip = localStorage.getItem('tolaut@skip') || null;
const status_pi = localStorage.getItem('tolaut@status_pi') || null;


class PrivateRoute extends React.Component {
 
  render() {
    if (!this.props.isAuthenticated) {
      return (
        <Redirect to="/login" />
      )
    } else {
      setUserProperties(analytics,  { role: form, email: email})
      // console.log(localStorage.getItem('tolaut@pi_expired'), localStorage.getItem('tolaut@skip'), localStorage.getItem('tolaut@status_pi') , localStorage.getItem('tolaut@typeUser'))
      if ((localStorage.getItem('tolaut@typeUser') || null) == ID_CONSIGNEE || (localStorage.getItem('tolaut@typeUser') || null) == ID_RESELLER) {
        if ((localStorage.getItem('tolaut@pi_expired') || null) == 'true' && (localStorage.getItem('tolaut@skip') || null) == 'false') {
          return <Redirect to="/login" />
        } else if ((localStorage.getItem('tolaut@pi_expired') || null) == 'true') {
          if((localStorage.getItem('tolaut@skip')|| null) === "true"){
            return <Route {...this.props} />
          }else{
            return <Redirect to="/expired/true" />
          }
        } else if ((localStorage.getItem('tolaut@pi_expired') || null) == 'false' && (localStorage.getItem('tolaut@status_pi') || null) == '0') {
          return <Redirect to="/expired/need-validate" />
        } else {
          return <Route {...this.props} />
        }
      } else {
        return (
          <Route {...this.props} />
        )
      }
    }
  }
}

export default PrivateRoute